// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","customLinkWrapper":"BuildProblemActions__customLinkWrapper--_O","customLink":"BuildProblemActions__customLink--RW"};